import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Button, CircularProgress, Dialog, IconButton, TextField } from "@mui/material";
import { Star, StarBorder, Title } from "@mui/icons-material";
const getCookie = require('../utils/getCookie')




const PageContainer = styled.div`
  margin: 16px;
  padding: 32px;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  box-shadow: 0px 0px 20px -18px #424242;
`;

const StarContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 16px 0;
`;

const ValidarForm = (props) => {
  const { id } = props.match.params;
  const [conteudo, setConteudo] = useState('');
  const [concluir, setConcluir] = useState('');
  const [openLoadingDialog, setOpenLoadingDialog] = useState(false)
  const [title, setTitle] = useState('');
  const [rating, setRating] = useState(0); // Estado para as estrelas
  const [isSatisfied, setIsSatisfied] = useState(false); // Estado para o botão "Satisfeito"

  const handleStarClick = (index) => {
    setRating(index + 1); // Define o número de estrelas selecionadas
  };

  const toggleSatisfaction = () => {
    setIsSatisfied(!isSatisfied);
  };

  useEffect(() => {
    carregarRegistro()


    if(concluir ==='sim' || concluir ==='nao'){
      onConcluir()


    }
  }, [rating,concluir])


  const red = () => {
    window.location.href = `${process.env.REACT_APP_DOMAIN}/atividade/${id}/edit`;
  };


  const onConcluir = () => {
    // alert("newStatus")
    setOpenLoadingDialog(true)


    const token = getCookie('_token_task_manager')
    const params = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        
        rating,
        conteudo,
        concluir
      })
    }

    fetch(`${process.env.REACT_APP_DOMAIN_API}/api/atividade/${id}/editFeedback`, params)
      .then(response => {
        const { status } = response
        response.json().then(data => {
          setOpenLoadingDialog(false)
          if (status === 401) {
            setOpenLoadingDialog(false)
           
            
          } else if (status === 200) {
            setOpenLoadingDialog(false)
          
         
            
            window.location.href = `${process.env.REACT_APP_DOMAIN}/atividade/${id}/edit`


            // setArea(data.data)
          }
        }).catch(err => setOpenLoadingDialog(true))
      })
  }


  function carregarRegistro() {
    setOpenLoadingDialog(true)
    
    const token = getCookie('_token_task_manager')
    const params = {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    }
    fetch(`${process.env.REACT_APP_DOMAIN_API}/api/atividade/${id?id:''}`, params)
      .then(response => {
        const { status } = response
        response.json().then(data => {
          if (status === 401) {
            setOpenLoadingDialog(false)
          
          } else if (status === 200) {
            setOpenLoadingDialog(false)
         
            setTitle(data.data.titulo)
           

          }
        }).catch(err => setOpenLoadingDialog(false))
      })
  }

  return (
    <PageContainer>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: 16,
        }}
      >

        <div style={{ flex: 1 }}></div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        
      <h2>Atividade: {title}</h2>
        <b style={{color:'red', fontSize:'13px'}}>Qual Seu nivel de satisfação na solução deste chamado?</b>
        <StarContainer>
          {Array(5)
            .fill(0)
            .map((_, index) => (
              <IconButton
                key={index}
                onClick={() => handleStarClick(index)}
                style={{
                  color: index < rating ? "#FFD700" : "#ddd",
                }}
              >
                {index < rating ? <Star /> : <StarBorder />}
              </IconButton>
            ))}
        </StarContainer>



        {rating === 0 ? ''


          :
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "16px", marginTop: "16px" }}>
  {/* Adicionando o textarea */}
  <textarea
    placeholder="Envie uma mensagem para o responsável pelo chamado"
    value={conteudo}
    onChange={e => setConteudo(e.target.value)}
    style={{
      width: "100%",
      maxWidth: "600px",
      height: "100px",
      padding: "10px",
      fontSize: "14px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      resize: "none", // Impedir redimensionamento
    }}
  ></textarea>


   

  {/* Botões lado a lado */}
  <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
    <Button
      variant="contained"
      style={{
        backgroundColor: "#007bff",
        color: "#fff",
        padding: "10px 20px",
        borderRadius: "4px",
        fontSize: "16px",
      }}
      onClick={() => setConcluir("sim")}
    >
      Concluir Chamado
    </Button>

    <Button
      variant="contained"
      style={{
        backgroundColor: "#dc3545",
        color: "#fff",
        padding: "10px 20px",
        borderRadius: "4px",
        fontSize: "16px",
      }}
       onClick={() => setConcluir("nao")}
    >
      Não finalizar este chamado
    </Button>
  </div>
</div>



        }





      </div>

      <Dialog open={openLoadingDialog}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: 120, height: 120 }}>
          <CircularProgress />
        </div>
      </Dialog>
    </PageContainer>
  );
};

export default ValidarForm;
